import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Content } from 'src/app/API.service';
import { ContentGridComponent } from '../content-grid/content-grid.component';
import { ContentGridSelectMode } from '../content-grid/content-grid-select-mode';
import { ContentGridElement } from '../content-grid/content-grid-element';

@Component({
  selector: 'app-content-select-dialog',
  templateUrl: './content-select-dialog.component.html'
})
export class ContentSelectDialogComponent implements OnInit {

  @ViewChild("grid") contentGrid: ContentGridComponent;

  @Input() selectMode: ContentGridSelectMode;
  @Input() selectedContentId: string;

  constructor(
    public dialogRef: MatDialogRef<ContentSelectDialogComponent, Array<ContentGridElement>>,
    @Inject(MAT_DIALOG_DATA) public data: { 
      selectMode: ContentGridSelectMode,
      selectedContentId: string,
      title: string
      selectButtonText: string
    }
  ) { }

  title: string = "Select Media";
  selectButtonText: string = "Select";
  contents: Array<Content> = [];
  adding: boolean = false;

  ngOnInit(): void {
    
    if (this.selectMode == undefined) {
      if (this.data == null || !this.data.selectMode){
        this.selectMode = ContentGridSelectMode.MULTIPLE
      } else {
        this.selectMode = this.data.selectMode;
      }
    }

    if (this.data != null) {
      if (this.selectedContentId == undefined) {
        this.selectedContentId = this.data.selectedContentId ?? null
      }
      this.title = this.data.title ?? this.title;
      this.selectButtonText = this.data.selectButtonText ?? this.selectButtonText;
    }

  }

  select() {
    this.dialogRef.close(Array.from(this.contentGrid.elements.values()).filter(e => e.selected));
  }

  cancel() {
    this.dialogRef.close([])
  }

}
